import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PackageService } from '@services/packages/package.service';
import { TranslateService } from '@services/translate/translate.service';
import { LabelsService } from '@services/labels/labels.service';

@Component({
    selector: 'front-profile-export-wizard',
    templateUrl: './front-profile-export-wizard.component.html',
    styleUrls: ['./front-profile-export-wizard.component.scss'],
    providers: [PackageService, LabelsService],
    standalone: false
})
export class FrontProfileExportWizardComponent implements OnInit {

  public fields: { name: string, translation?: string, title?: string, selected: boolean }[] = [
    { name: 'firstName', translation: 'myUsers.firstName', selected: true },
    { name: 'lastName', translation: 'myUsers.lastName', selected: true },
    { name: 'email', translation: 'myUsers.email', selected: true },
    { name: 'mobile', translation: 'myUsers.mobile', selected: true },
    { name: 'state', translation: 'myUsers.isActivated', selected: true }
  ];

  constructor(
    public dialogRef: MatDialogRef<FrontProfileExportWizardComponent>, private packageService: PackageService, public translateService: TranslateService,
    private labelService: LabelsService, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.translateService.get();
  }

  ngOnInit() {
    this.init();
  }

  async init() {
    const pak = await this.packageService.get(this.data.packageId);
    const additionalConfig = pak.additionalFrontProfileFields;
    for (const key of Object.keys(additionalConfig || {})) {
      this.fields.push({ name: key, title: additionalConfig[key].translations.de.title, selected: true });
    }
    const labels = await this.labelService.find(0, 100, { packageId: this.data.packageId});
    if (labels && labels.data && labels.data.length) {
      this.fields.push({ name: 'labels', title: 'Labels', selected: true });
    }
  }

  abort() {
    this.dialogRef.close();
  }

  finish() {
    if (this.fields.filter(el => el.selected).length > 0) {
      this.dialogRef.close(this.fields);
    }
  }

}
